import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import Typography from '@mui/material/Typography';
import Pagination from '@mui/material/Pagination';
import MuiGrid from '@mui/material/Grid';

// Components
import { Spinner } from '@arredo/reactjs-ui';
import Head from './header';
import Items from './items/item';
import CreateFab from '../buttons/create';
import useStyles from './styles';

const Grid = ({ columns, rows, loading, paginationProps, rowPros = {}, onCreate, createLabel }) => {
  const { classes } = useStyles();

  const { onView, onCopy, onDelete, onUpdate, onSelect, customCells, lastRowStyle } = rowPros;

  return (
    <>
      <MuiGrid container spacing={1} className={classes.root}>
        {columns.length > 0 &&
          <MuiGrid size={12}>
            <Head
              actionsButtons={!!onView + !!onCopy + !!onDelete + !!onUpdate + !!customCells}
              headers={columns.map(c => ({
                align: c.align,
                value: c.header,
                sizes: c.sizes
              }))}
              selection={!!onSelect}
            />
          </MuiGrid>
        }
        {loading &&
          <MuiGrid style={{ margin: 8 }} size={12}>
            <Spinner message='Buscando' />
          </MuiGrid>
        }

        {!loading &&
          <>
            <MuiGrid size={12}>
              <MuiGrid container spacing={1}>
                {
                  rows.length === 0
                    ? <MuiGrid size={12}>
                      <Typography align='center' variant='h6' style={{ margin: 8 }}>
                        No se encontraron resultados
                      </Typography>
                    </MuiGrid>
                    : rows.map((row, index) => {
                      return (
                        <MuiGrid key={index} size={12}>
                          <Items
                            {...rowPros}
                            row={row}
                            columns={columns}
                            lastRowStyle={(rows.length === index + 1) ? lastRowStyle : {}}
                          />
                        </MuiGrid>
                      );
                    })
                }
              </MuiGrid>
            </MuiGrid>
            {
              paginationProps &&
              <MuiGrid container justifyContent='center' size={12}>
                <Pagination
                  size="medium"
                  color='primary'
                  siblingCount={2}
                  {...paginationProps}
                />
              </MuiGrid>
            }
          </>
        }
      </MuiGrid>
      {onCreate &&
        <CreateFab label={createLabel} onClick={onCreate} />
      }
    </>
  );
}

Grid.defaultProps = {
  columns: [],
  rows: [],
  loading: false
}

Grid.prototype = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      field: PropTypes.string.isRequired,
      header: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      tooltip: PropTypes.func,
      alt: PropTypes.string,
    })).isRequired,
  rows: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool,
  paginationProps: PropTypes.object,
  rowPros: PropTypes.shape({
    align: PropTypes.string,
    onView: PropTypes.func,
    onUpdate: PropTypes.func,
    onDelete: PropTypes.func,
    onShowUpdate: PropTypes.func,
    onShowDelete: PropTypes.func,
    customCells: PropTypes.func,
    onCopy: PropTypes.func
  }),
  onCreate: PropTypes.func,
  createLabel: PropTypes.string
}

export default Grid;